import { useCallback } from 'react';
import {
  type NavigateOptions,
  type To,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { preserveCurrentSearch } from '@utils/navigationSearch';

// react-router navigate wrap that does not lose search params
// unless you specify your search params
export function useNavigateKeepSearch() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      navigate(preserveCurrentSearch(to, searchParams), options);
    },
    [navigate, searchParams],
  );
}
